import type { MapViewRequestQueries } from "../services/ajax/types";
import { updateSearchFormInputs } from "./global-header-utils";

const updateMapSearchParams = ({ zipcode, distance, sources }: MapViewRequestQueries) => {
  if (!zipcode || !distance) return;
  const params = new URLSearchParams(window.location.search);
  params.set("zipcode", zipcode);
  params.set("distance", distance);
  if (sources) {
    params.set("sources", sources);
  }
  window.history.replaceState({}, "", `${window.location.pathname}?${params}`);

  // Update hidden form inputs in global header to sync with URL params
  updateSearchFormInputs(zipcode, distance);
};

export default updateMapSearchParams;
